import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"40%"} }
const _hoisted_2 = { class: "d-flex mb-4" }
const _hoisted_3 = { class: "mr-10 mt-4" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "mr-7 mt-4" }
const _hoisted_6 = { class: "d-flex justify-end mt-3" }

import BaseAutoCompleteWithSingleSelectedItem from "@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue"
import organizationType from "@/types/requests/organizationType"
import FormRow from "@/components/Common/FormRow.vue"
import getRole from "@/types/responses/getRole"
import { computed } from "vue"
import i18n from "@/lang/i18n"

type searchItemsType = {
  organization: {
    id: number,
    name: string,
    type: string
  } | null,
  userName: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserSearch',
  props: {
    selectedRole: {},
    modelValue: {},
    windowInnerWidth: {},
    filter: { type: Function },
    organizations: {},
    errorMessages: {},
    loading: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(FormRow, {
    title: _unref(i18n).global.t('pages.roleAssignment.form.search.title'),
    windowInnerWidth: props.windowInnerWidth
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h6", null, [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.roleAssignment.form.search.organization')), 1),
              _cache[2] || (_cache[2] = _createElementVNode("span", { style: {"color":"red"} }, "✴︎", -1))
            ])
          ]),
          _createVNode(BaseAutoCompleteWithSingleSelectedItem, {
            modelValue: modelValue.value.organization,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.organization) = $event)),
            items: props.organizations,
            itemName: "name",
            errorMessages: props.errorMessages.userSearchOrganization
          }, null, 8, ["modelValue", "items", "errorMessages"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h6", null, _toDisplayString(_unref(i18n).global.t('pages.roleAssignment.form.search.userName')), 1)
          ]),
          _createVNode(_component_v_text_field, {
            modelValue: modelValue.value.userName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.userName) = $event)),
            outlined: "",
            dense: "",
            class: "mt-2"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_btn, {
            class: "exec-btn",
            onClick: props.filter,
            loading: props.loading
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.roleAssignment.form.search.search')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "windowInnerWidth"]))
}
}

})